function levenshteinDistance(s, t) {
	s = s.toLowerCase();
	t = t.toLowerCase();
  const m = s.length, n = t.length;
  let d = [];
  for (let i = 0; i <= m; i++) {
    d[i] = [i];
    for (let j = 1; j <= n; j++) {
      d[i][j] = i === 0 ? j : 0;
    }
  }
  for (let j = 1; j <= n; j++) {
    for (let i = 1; i <= m; i++) {
      const cost = s[i - 1] === t[j - 1] ? 0 : (i*j);
      d[i][j] = Math.min(
        d[i - 1][j] + 1,
        d[i][j - 1] + 1,
        d[i - 1][j - 1] + cost
      );
    }
  }
  return d[m][n];
}

function fuzzyScore(needle, haystack) {
	let terms = haystack.split(' ');
	terms.push(haystack); // 'a b' -> ['a', 'b', 'a b']
	let scores = terms.map(nm => {
		let ld = levenshteinDistance(needle, nm);
		return ld / Math.max(needle.length, nm.length);
	});
	
	// Pick the lowest score
	return scores.reduce((acc, curr) => acc < curr ? acc : curr);
}

export { levenshteinDistance, fuzzyScore }